import React from 'react'
import LinkWithIcon from './buttons/LinkWithIcon'
import Support from '../svgs/Support'
import { User } from '../../api/Users/Types'
import classNames from 'classnames'

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  user?: User
  text?: string
  trackingKey?: string
  noIcon?: boolean
  openNewWindow?: boolean
  href?: string
  analyticId?: string
}

const TalkToExpertButton: React.FC<Props> = ({
  user,
  text = 'Talk to an expert',
  trackingKey = 'book_meeting_home',
  className,
  noIcon,
  openNewWindow,
  href,
  analyticId,
  ...rest
}) => {
  const classes = classNames('book-meeting-button', className)

  function trackClickBookMeeting(): void {
    if (!trackingKey) return

    GoogleAnalyticsHelper.VentionGAEvent(trackingKey, 'click', 'funnel', user?.id)
  }

  return (
    <div className={classes} onClick={trackClickBookMeeting} {...rest}>
      {noIcon ? (
        <a
          className='button button-lg button-vention'
          href={href ? href : '/talk-to-expert'}
          target={openNewWindow ? '_blank' : undefined}
          data-analytic-id={analyticId}
        >
          {text}
        </a>
      ) : (
        <>
          <LinkWithIcon
            icon={<Support />}
            target={href ? href : '/talk-to-expert'}
            text={text}
            arrowRight
            openNewWindow={openNewWindow}
            analyticId={analyticId}
          />
        </>
      )}
    </div>
  )
}

export default TalkToExpertButton
